import { isEmpty } from "lodash";
import type { RootState } from "store/types";
import { charFromCode } from "utils/charCode";

// `links` (src/reducers/links.js) is a new slice unwound at the selector boundary (Phase 0b's
// per-slice-on-demand pattern, following store/selectors/filters.ts).
export function selectDecimalPlaces(state: RootState): number | undefined {
  return state.links.get("decimalPlaces");
}

// containers/Games (PLAY-5160): mapStateToProps' derivation logic ported verbatim.
export function selectIsMultiGame(state: RootState): boolean {
  return !!state.links.get("isMultiGame");
}

export function selectCurrency(state: RootState): string | null {
  const currency = state.links.get("currency");
  return isEmpty(currency) ? null : currency;
}

export function selectIsResponsiveGameDisplayEnabled(state: RootState): boolean | undefined {
  return state.links.getIn(["isResponsiveGameDisplayEnabled"]);
}

export function selectIsOneClickPlayEnabled(state: RootState): boolean | undefined {
  return state.links.get("isOneClickPlayEnabled");
}

// containers/GameNavigation (PLAY-5216, Phase 1).
export function selectSearch(state: RootState): boolean | undefined {
  return state.links.get("search");
}

export function selectAllowMultiGamePlay(state: RootState): boolean | undefined {
  try {
    return state.links.get("allowMultiGamePlay");
  } catch {
    return undefined;
  }
}

export function selectGameLobbyBannerUrls(state: RootState): any {
  return state.links.getIn(["gameLobbyBannerUrls"]);
}

export function selectGetPages(state: RootState): any {
  return state.links.getIn(["getPages"]);
}

// containers/Application (PLAY-5216, Phase 4).
export function selectGetBalance(state: RootState): any {
  return state.links.get("getBalance");
}

export function selectNotificationUrl(state: RootState): any {
  return state.links.getIn(["notificationUrls", 0]);
}

export function selectWlProfile(state: RootState): any {
  return state.links.get("wl.profile");
}

export function selectMode(state: RootState): any {
  return state.links.get("mode");
}

export function selectShowBanner(state: RootState): any {
  return state.links.getIn(["showBanner"]);
}

// containers/LeaderBoard (PLAY-5216, Phase 2): mapStateToProps' hex-codepoint decode ported
// verbatim.
export function selectSymbol(state: RootState): string | undefined {
  try {
    return charFromCode(Number.parseInt(state.links.getIn(["symbol", 0]), 16));
  } catch {
    return undefined;
  }
}

// containers/Category (PLAY-5216, Phase 3): mapStateToProps' char-code-array decode ported
// verbatim - distinct from selectSymbol above (a single hex codepoint) and from user.ts's
// selectUserSymbol (a different slice), same char-code-array shape as that one though.
export function selectLinksSymbol(state: RootState): string | null {
  const symbolList = state.links.getIn(["symbol"]);
  if (isEmpty(symbolList)) {
    return null;
  }
  return symbolList.map((symbol: number) => charFromCode(symbol)).toJSON().join("");
}
